import React from 'react';

function ApplicationFooter(props){
    return <div className="application-footer">
        Application Footer
    </div>
}

export default ApplicationFooter;
